<template>
    <li class="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200">
        <span v-if="active"
              class="absolute inset-y-0 left-0 w-1 bg-red-600 rounded-tr-lg rounded-br-lg"
              aria-hidden="true"
        ></span>
        <inertia-link class="inline-flex items-center w-full"
                      :class="{'text-gray-800 dark:text-gray-100': active}"
                      :href="href">
            <div class="w-5 h-5"><slot name="icon"></slot></div>
            <span class="ml-4"><slot name="title"></slot></span>
        </inertia-link>
    </li>
</template>

<script>
export default {
    name: "SidebarSubmenuItem",
    props: {
        href: String,
        active: {
          type: Boolean,
          default: false
        }
    }
}
</script>

<style scoped>

</style>
